export default __webpack_public_path__ + "static/media/IUSD+.21483dda.png";